import moment from 'moment-timezone';

export type DataExportResource = 'clients' | 'pets' | 'appointments' | 'invoices';

export type DataExportStatus = 'pending' | 'processing' | 'completed' | 'failed';

export interface DataExport {
    id: string;
    resource: DataExportResource;
    status: DataExportStatus;
    rowCount: number | null;
    /** Empty means every location of the organization. */
    locationIds: Array<number>;
    /** YYYY-MM-DD, both null for "All time". */
    startDate: string | null;
    endDate: string | null;
    requestedBy: string | null;
    createdAt: string;
    completedAt: string | null;
    urlExpiresAt: string | null;
    downloadUrl: string | null;
    failureReason: string | null;
}

export interface CreateDataExport {
    resource: DataExportResource;
    /** Empty means every location of the organization. */
    locationIds: Array<number>;
    startDate: string | null;
    endDate: string | null;
}

// Same cap the backend enforces per organization (APIExport::MAX_CONCURRENT_PER_ORGANIZATION).
export const MAX_RUNNING_DATA_EXPORTS = 5;

export const isDataExportRunning = (dataExport: DataExport): boolean =>
    dataExport.status === 'pending' || dataExport.status === 'processing';

// The download link is signed and expires; past that point the file has to be generated again.
export const isDataExportExpired = (dataExport: DataExport): boolean =>
    dataExport.status === 'completed' &&
    (!dataExport.urlExpiresAt || moment(dataExport.urlExpiresAt).isBefore(moment()));
